<template>
    <div>
        <!-- <div v-if="Names == ''">
            <Mainlayout></Mainlayout>
        </div>
        <div v-else>
            <MainlayoutLogin></MainlayoutLogin>
        </div> -->
        <Mainlayout></Mainlayout>
        <CCol sm="12" style="background-size: cover;" :style="{ backgroundImage: `url(${backgroundUrl})` }">
            <CCol sm="12" lg="12">
                <CRow>
                    <CCol sm="12" lg="12">
                        <div style="margin-top: 20%; margin-bottom:10%">
                            <h1 class="font-general-sans text-center custom-40px-600">
                                Speed Up Your Interview Process with AI Technology
                            </h1>
                            <p class="custom-18px-500 text-center mt-3">In today's fast-paced business world, time is money. AI-powered interview technology streamlines the<br /> recruitment process, saving you valuable hours and resources. Our platform automates repetitive tasks like <br /> resume
                                screening and interview scheduling, allowing you to focus on the most qualified candidates and make <br /> informed hiring decisions faster.</p>
    
    
                        </div>
                        <br />
    
                    </CCol>
    
                </CRow>
            </CCol>
        </CCol>
    
        <CCol sm="12" class="bg-FAFAFA">
            <CCol sm="12" style="width: 90%;background-size: cover; margin: auto;">
                <div class="text-center">
                    <CRow>
                        <CCol sm="12">
                            <h3 class="custom-48px-600 text-center mt-3"> Our Story </h3>
                        </CCol>
    
    
                        <CCol sm="12 mt-3">
                            <img style="max-width:100%" src="../assets/img/playvideo.png" alt="Interviewrr.ai play video icon"/>
                        </CCol>
                        <CCol sm="6">
                            <p class="custom-16px-400 text-left mt-3">Our story began with a shared frustration: the recruitment process was broken. Talented candidates were overlooked, good companies missed out on great hires, and biases unfairly influenced decisions. We saw the transformative potential
                                of AI and knew we could build a better way</p>
                        </CCol>
                        <CCol sm="6">
                            <p class="custom-16px-400 text-left mt-3">Our story began with a shared frustration: the recruitment process was broken. Talented candidates were overlooked, good companies missed out on great hires, and biases unfairly influenced decisions. We saw the transformative potential
                                of AI and knew we could build a better way</p>
                        </CCol>
                    </CRow>
                </div>
            </CCol>
            <br /><br /><br />
        </CCol>
    
    
        <CCol sm="12" class="bg-grey">
            <CCol sm="12" style="width: 90%;background-size: cover; margin: auto;">
                <div class="text-center">
                    <br /><br /><br />
                    <CRow>
                        <CCol sm="12">
                            <h1 class="custom-48px-600 text-center mt-3">
                                Building a Better Tomorrow with AI
                            </h1>
                            <p class="custom-18xp-400 text-center font-general-sans font-color-696969 mt-2">Powered by state-of-the-art AI technology, we're dedicated to helping job seekers hone their interview skills and secure their ideal positions with confidence.</p>
                            <CRow>
                                <CCol sm="6">
                                    <CCard class="bg-white b-20 p-20" style="border:none">
                                        <img src="../assets/img/LAYER.png" style="width:40px" class="m-4" alt="Interviewrr.ai icon layer"/>
                                        <h3 class="custom-24px-500 text-left ml-4">
                                            Our Mission
                                        </h3>
                                        <p class="custom-18px-400 text-left ml-4">
                                            is to empower recruiters and job seekers with AI-driven interview technology that delivers speed, accuracy, and fairness.
                                        </p>
                                        <ul class="text-left">
                                            <li>
                                                <span class="custom-18px-700 text-left">Speed: </span> We aim to streamline the recruitment process, reducing the time it takes to identify and hire top talent.
                                            </li>
                                            <li>
                                                <span class="custom-18px-700 text-left">Accuracy:</span> Our AI algorithms are designed to objectively assess candidates' skills and qualifications, eliminating bias and improving hiring decisions.</li>
                                            <li>
                                                <span class="custom-18px-700 text-left">Fairness: </span>We believe that everyone deserves a fair chance to showcase their potential, regardless of background or experience. Our AI platform promotes equal opportunities
                                                for all.</li>
                                        </ul>
                                    </CCard>
                                </CCol>
                                <CCol sm="6">
                                    <CCard class="bg-purple-rainbow b-20 p-20" style="border:none">
                                        <img src="../assets/img/Iconthunder.png" style="width:40px" class="m-4" alt="Interviewrr.ai icon thunder"/>
                                        <h3 class="custom-24px-500 text-left ml-4 text-white">
                                            Our Values
                                        </h3>
                                        <p class="custom-18px-400 text-left ml-4 text-white">
                                            are the bedrock of our company culture, guiding our actions and decisions every step of the way.
                                        </p>
                                        <ul class="text-left text-white">
                                            <li>
                                                <span class="custom-18px-700 text-left text-white">Innovation: </span>We are committed to continuous innovation, constantly pushing the boundaries of AI-powered recruitment solutions.
                                            </li>
                                            <li>
                                                <span class="custom-18px-700 text-left text-white">Integrity:</span> We uphold the highest ethical standards in everything we do, ensuring that our technology is used responsibly and transparently.</li>
                                            <li>
                                                <span class="custom-18px-700 text-left text-white">Customer-focus: </span>We are dedicated to providing exceptional service to our clients, both recruiters and job seekers, ensuring their success in the ever-evolving
                                                hiring landscape. for all.</li>
                                        </ul>
                                    </CCard>
                                </CCol>
                            </CRow>
                        </CCol>
                    </CRow>
    
                </div>
            </CCol>
        </CCol>
    
        <CCol sm="12" class="bg-grey">
            <CCol sm="12" style="width: 80%;background-size: cover; margin: auto;">
                <div class="text-center">
                    <br /><br /><br />
                    <CRow>
                        <CCol sm="12">
                            <h1 class="custom-48px-600 text-center mt-3 mb-4">
                                Building a Better Tomorrow with AI
                            </h1>
                            <CRow>
                                <CCol sm="4">
                                    <img style="max-width:80%" src="../assets/img/bos.jpg" alt="CEO of Interviewrr.ai"/>
                                </CCol>
                                <CCol sm="8">
                                    <div class="text-left">
                                        <h3 class="custom-40px-600 text-left mt-5">We Believe Innovation is The Key to Build a Better Future for Our People.</h3>
                                        <p class="custom-16px-400 text-left mb-5 mt-3">In the genesis of Interviewer, our vision was clear: to create a space where skilled professionals can thrive, where their expertise is not just recognized but elevated. Our journey started with a belief that every
                                            individual, regardless of experience, deserves a platform to showcase their skills and connect with those seeking top-tier services.</p>
                                 
                                        <h3 class="custom-16px-600 mt-3">
                                            Rasid
                                        </h3>
                                        <p class="custom-12px-400">
                                            Founder and CEO Interviewrr
                                        </p>
                                    </div>
                                </CCol>
                            </CRow>
                        </CCol>
                    </CRow>
    
                </div>
            </CCol>
        </CCol>
    
        <CCol sm="12" class="bg-grey">
            <CCol sm="12" style="width: 80%;background-size: cover; margin: auto;">
                <div class="text-center">
                    <br /><br /><br />
                    <CRow>
                        <CCol sm="6">
                            <h1 class="custom-48px-600 text-left mt-3">
                                Benefits of AI Interviews
                            </h1>
                            <p class="custom-18xp-400 text-left font-general-sans font-color-696969 mt-4">Create a detailed list of the benefits AI brings to both recruiters and job candidates. Examples: reduced time-to-hire, improved candidate experience, unbiased decision-making.</p>
                            <CRow class="mt-3">
                                <CCol sm="6">
                                    <CCard class="bg-white b-20 p-20" style="border:none">
                                        <img src="../assets/img/iconmentol.png" style="width:20px" class="m-4" alt="Interviewrr.ai mentorship icon"/>
                                        <h3 class="custom-24px-500 text-left ml-4">
                                            Innovation
                                        </h3>
                                        <p class="custom-16px-400 text-left ml-4">
                                            We're committed to pushing the boundaries of technology to create innovative solutions that empower job seekers.
                                        </p>
                                    </CCard>
                                </CCol>
                                <CCol sm="6">
                                    <CCard class="bg-white b-20 p-20" style="border:none">
                                        <img src="../assets/img/iconlight.png" style="width:20px" class="m-4" alt="Interviewrr.ai light icon"/>
                                        <h3 class="custom-24px-500 text-left ml-4">
                                            Empowerment
                                        </h3>
                                        <p class="custom-16px-400 text-left ml-4">
                                            We believe in providing individuals with the tools and resources they need to succeed in their professional endeavors. </p>
                                    </CCard>
                                </CCol>
                            </CRow>
                        </CCol>
                        <CCol sm="6">
                            <CCol sm="6">
                            <img style="max-width:420px" src="../assets/img/mentol.png" class="mt-3 d-sm-down-none" data-aos="zoom-out" alt="Interviewrr.ai mentol icon"/>
                            <img style="max-width:100%" src="../assets/img/mentol.png" class="mt-3 d-md-none" data-aos="zoom-out" alt="Interviewrr.ai mentol icon"/>
                        </CCol>
                        </CCol>
                    </CRow>
    
                </div>
            </CCol>
        </CCol>
    
        <CCol sm="12" class="bg-grey">
            <CCol sm="12" style="width: 90%;background-size: cover; margin: auto;">
                <div class="text-center">
                    <br /><br /><br />
                    <CRow>
                        <CCol sm="12">
                            <h1 class="custom-48px-600 text-center mt-3 mb-4">
                                Meet our Team
                            </h1>
                            <CRow>
                                <CCol sm="4"><img style="max-width:80px" src="../assets/img/us1.png" alt="Interviewrr.ai user icon"/>
                                    <h3 class="custom-20px-400 mt-3">Dr.Sayed Irfan</h3>
                                    <h4 class="custom-14px-600 font-color-purple">CTO & Co Founder</h4>
                                    <img src="../assets/img/tw1.png" style="max-width:20px" class="mr-2" alt="Interviewrr.ai twitter icon"/>
                                    <img src="../assets/img/in1.png" style="max-width:20px" class="mr-2" alt="Interviewrr.ai in icon"/>
                                    <img src="../assets/img/dr1.png" style="max-width:20px" alt="Interviewrr.ai dr icon"/></CCol>
                                    <CCol sm="4"><img style="max-width:80px" src="../assets/img/id.png" alt="Interviewrr.ai user icon"/>
                                    <h3 class="custom-20px-400 mt-3">Irdina Izzati</h3>
                                    <h4 class="custom-14px-600 font-color-purple">CMO & co founder</h4>
                                    <img src="../assets/img/tw1.png" style="max-width:20px" class="mr-2" alt="Interviewrr.ai twitter icon"/>
                                    <img src="../assets/img/in1.png" style="max-width:20px" class="mr-2" alt="Interviewrr.ai in icon"/>
                                    <img src="../assets/img/dr1.png" style="max-width:20px" alt="Interviewrr.ai dr icon"/></CCol>
                                <CCol sm="4"><img style="max-width:80px" src="../assets/img/us2.png" alt="Interviewrr.ai user icon"/>
                                    <h3 class="custom-20px-400 mt-3">Faris</h3>
                                    <h4 class="custom-14px-600 font-color-purple">AI Developer</h4>
                                    <img src="../assets/img/tw1.png" style="max-width:20px" class="mr-2" alt="Interviewrr.ai twitter icon"/>
                                    <img src="../assets/img/in1.png" style="max-width:20px" class="mr-2" alt="Interviewrr.ai in icon"/>
                                    <img src="../assets/img/dr1.png" style="max-width:20px" alt="Interviewrr.ai dr icon"/></CCol>
    
                                <CCol sm="3"><img style="max-width:80px" src="../assets/img/us3.png" alt="Interviewrr.ai user icon"/>
                                    <h3 class="custom-20px-400 mt-3">Nadia</h3>
                                    <h4 class="custom-14px-600 font-color-purple">Back End Programmer</h4>
                                    <img src="../assets/img/tw1.png" style="max-width:20px" class="mr-2" alt="Interviewrr.ai twitter icon"/>
                                    <img src="../assets/img/in1.png" style="max-width:20px" class="mr-2" alt="Interviewrr.ai in icon"/>
                                    <img src="../assets/img/dr1.png" style="max-width:20px" alt="Interviewrr.ai dr icon"/></CCol>
                                <CCol sm="3"><img style="max-width:80px" src="../assets/img/us4.png" alt="Interviewrr.ai user icon"/>
                                    <h3 class="custom-20px-400 mt-3">Nurul</h3>
                                    <h4 class="custom-14px-600 font-color-purple">Front End Programmer</h4>
                                    <img src="../assets/img/tw1.png" style="max-width:20px" class="mr-2" alt="Interviewrr.ai twitter icon"/>
                                    <img src="../assets/img/in1.png" style="max-width:20px" class="mr-2" alt="Interviewrr.ai in icon"/>
                                    <img src="../assets/img/dr1.png" style="max-width:20px" alt="Interviewrr.ai dr icon"/></CCol>
    
                                <CCol sm="3"><img style="max-width:80px" src="../assets/img/us5.png" alt="Interviewrr.ai user icon"/>
                                    <h3 class="custom-20px-400 mt-3">Siti Tirta Dinar</h3>
                                    <h4 class="custom-14px-600 font-color-purple">Product Designer</h4>
                                    <img src="../assets/img/tw1.png" style="max-width:20px" class="mr-2" alt="Interviewrr.ai twitter icon"/>
                                    <img src="../assets/img/in1.png" style="max-width:20px" class="mr-2" alt="Interviewrr.ai in icon"/>
                                    <img src="../assets/img/dr1.png" style="max-width:20px" alt="Interviewrr.ai dr icon"/></CCol>
                                <CCol sm="3"><img style="max-width:80px" src="../assets/img/us6.png" alt="Interviewrr.ai user icon"/>
                                    <h3 class="custom-20px-400 mt-3">Shahira</h3>
                                    <h4 class="custom-14px-600 font-color-purple">Customer Experience Manager</h4>
                                    <img src="../assets/img/tw1.png" style="max-width:20px" class="mr-2" alt="Interviewrr.ai twitter icon"/>
                                    <img src="../assets/img/in1.png" style="max-width:20px" class="mr-2" alt="Interviewrr.ai in icon"/>
                                    <img src="../assets/img/dr1.png" style="max-width:20px" alt="Interviewrr.ai dr icon"/></CCol>
                            </CRow>
                        </CCol>
                    </CRow>
                    <br /><br /><br />
                </div>
            </CCol>
        </CCol>
    
    
    
    
    
    
    
    
        <CCol sm="12" class="p-1" style="background-size: cover;color: #fff">
            <br /> <br /> <br />
            <CCol sm="12" lg="12">
                <div class="text-center p-2">
                    <CCol sm="12" style="width: 80%;margin: auto;" class="d-sm-down-none">
                        <div class="text-center" style="background-size: cover;border-radius: 20px;" :style="{ backgroundImage: `url(${backgroundUrNoArrow})` }">
                            <br />
                            <br /> <br /> <br />
                            <h1 class="custom-header-join text-white poppin-font text-48px mt-5">Subscribe Now for Free</h1>
                            <br />
                            <label class="custom-header-join-sub text-white">
                                                Sign up now for free and take the first step toward landing your dream job!
                                                                                </label>
                            <br />
                            <br /> <br /> <br />
                            <CButton class="button-Explore"><span class="ml-2 mr-2">Inquire</span></CButton>
                            <br />
                            <br /> <br /> <br />
                            <br />
                        </div>
                    </CCol>

                    <CCol sm="12" style="width: 100%;margin: auto;" class="d-md-none">
                        <div class="text-center" style="background-size: cover;border-radius: 20px;" :style="{ backgroundImage: `url(${backgroundUrNoArrow})` }">
                            <br />
                            <br /> <br /> <br />
                            <h1 class="custom-header-join text-white poppin-font text-48px mt-5">Subscribe Now for Free</h1>
                            <br />
                            <label class="custom-header-join-sub text-white">
                                                Sign up now for free and take the <br /> first step toward landing your dream job!
                                                                                </label>
                            <br />
                            <br /> <br /> <br />
                            <CButton class="button-Explore"><span class="ml-2 mr-2">Inquire</span></CButton>
                            <br />
                            <br /> <br /> <br />
                            <br />
                        </div>
                    </CCol>
                </div>
                <br /><br /><br />
            </CCol>
    
    
        </CCol>
    
        <Footerlayout></Footerlayout>
    
    </div>
</template>

<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgPurpleYellow.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bgline.png";

import Mainlayout from "../containers/AllHeaderBlack.vue";
import MainlayoutLogin from "../containers/LoginHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';


export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        MainlayoutLogin,
        Footerlayout,
        ToggleCard,
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundUrNoArrow,

            backgroundGenie,
            isActive: false,

            Names: ""

        };
    },
    created() {
        AOS.init();
    },
    mounted() {
        // const isAuth = this.UserAuth();
        //     if (isAuth) {
        //     this.GetInfoUser();
        // } else {
        //     this.loading = false; // If not authenticated, immediately set loading to false
        // }
},
    methods: {
        toggle() {
            this.isActive = !this.isActive;
        },
        GotoHowItWork() {
            this.$router.push("HowItWork");
        },
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, { withCredentials: true });
                if (response.status === 200 && response.data) {
                    this.user = response.data;
                    this.Names = this.user.name;
                } else {
                    this.$router.push("About");
                    console.error("User info retrieval failed:", response.data.detail);
                }
            } catch (error) {
                this.$router.push("About");
                console.error("Error fetching user info:", error);
            }
        },
    },

};
</script>

<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}
</style>